import { EnumList } from './pipes/enum-list.pipe';
import {
    FOR_ROOT_SETTINGS_TOKEN,
    ModuleSettings,
    provideSettings,
    Settings
    } from './settings';
import { LoggingModule } from './logging/logging.module';
import { LogService } from './logging/log.service';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { UpperCaseDirective } from './directives/upper-case.directive';

@NgModule({
    imports: [
        LoggingModule
    ],
    declarations: [
        EnumList,
        UpperCaseDirective
    ],
    exports: [
        EnumList,
        UpperCaseDirective
    ]
})
export class CommonComponentsModule {
    public static forRoot(moduleSettingsFactory: () => ModuleSettings): ModuleWithProviders<CommonComponentsModule> {
        return {
            ngModule: CommonComponentsModule,
            providers: [
                { provide: FOR_ROOT_SETTINGS_TOKEN, useValue: moduleSettingsFactory },
                { provide: Settings, useFactory: provideSettings, deps: [FOR_ROOT_SETTINGS_TOKEN] },
                LogService
            ]
        };
    }
}
